import {
  LEARNING_OBJECTIVE_MAXIMUM,
  LEARNING_OBJECTIVE_MINIMUM,
  SKILLS_MINIMUM,
} from 'bundles/enterprise-admin-learning-path/constants';
import type { CurriculumItem } from 'bundles/naptimejs/resources/programCurriculums.v1';

export const getActivities = (curriculumItems: CurriculumItem[]) =>
  curriculumItems
    .map((_) => (_.typeName === 'courseId' ? { courseId: _.definition.id } : { courseId: '' }))
    .filter((_) => _.courseId);

export const isLegacyEnterpriseBadge = (badge?: { learningObjectives: {}[]; skillsMetadata: ({} | null)[] }) => {
  const invalidObjectives =
    badge?.learningObjectives?.length &&
    (badge.learningObjectives?.length < LEARNING_OBJECTIVE_MINIMUM ||
      badge.learningObjectives.length > LEARNING_OBJECTIVE_MAXIMUM);
  const invalidSkills = !badge?.skillsMetadata?.length || badge.skillsMetadata.length < SKILLS_MINIMUM;
  return badge && Boolean(invalidObjectives || invalidSkills);
};
